import { z } from "zod";
import {
  adGroupMetaBaseSchema,
  validateAdGroupMeta,
} from "./adGroupMetaSchema";
import {
  adGroupGoogleBaseSchema,
  validateAdGroupGoogle,
} from "./adGroupGoogleSchema";
import {
  adGroupTiktokBaseSchema,
  validateAdGroupTikTok,
} from "./adGroupTikTokSchema";
import { GOOGLE, META, TIKTOK } from "../../../../../utils/constants";
import { CAMPAIGN_FORM_ZOD_PARAMS } from "../campaignFormZod";

import { adMetaSchema } from "../ad/adMetaSchema";
import { adGoogleBaseSchema } from "../ad/adGoogleSchema";
import { adTikTokBaseSchema } from "../ad/adTikTokSchema";

const adGroupBaseSchema = z.discriminatedUnion("platform", [
  adGroupMetaBaseSchema,
  adGroupGoogleBaseSchema,
  adGroupTiktokBaseSchema,
]);

const getValidationAdGroup = ({
  campaign,
  integrations,
  adGroup,
  indexAdGroup,
  ctx,
  platform,
  currencyTaxes,
}) => {
  switch (platform) {
    case GOOGLE:
      validateAdGroupGoogle({
        campaign,
        integrations,
        adGroup,
        indexAdGroup,
        ctx,
      });
      break;
    case TIKTOK:
      validateAdGroupTikTok({
        campaign,
        integrations,
        adGroup,
        indexAdGroup,
        ctx,
      });
      break;
    case META:
      validateAdGroupMeta({
        campaign,
        integrations,
        adGroup,
        indexAdGroup,
        ctx,
        currencyTaxes,
      });
      break;

    default:
      break;
  }
};

const getValidationAd = (platform) => {
  switch (platform) {
    case GOOGLE:
      return ({ campaign, adGroup, indexAdGroup, indexAd }) =>
        adGoogleBaseSchema({
          campaign,
          adGroup,
          indexAdGroup,
          indexAd,
        });
    case TIKTOK:
      return adTikTokBaseSchema;
    case META:
      return adMetaSchema;

    default:
      return null;
  }
};

export const adGroupSchema = ({
  campaign,
  integrations,
  indexAdGroup,
  currencyTaxes,
}) =>
  adGroupBaseSchema.superRefine((data, ctx) => {
    getValidationAdGroup({
      campaign,
      integrations,
      adGroup: data,
      indexAdGroup,
      ctx,
      platform: data.platform,
      currencyTaxes,
    });

    const ads = data.ads || [];
    ads.forEach((ad, indexAd) => {
      const validationAd = getValidationAd(ad.platform);
      if (!validationAd) {
        return;
      }

      const safeAd = validationAd({
        campaign,
        integrations,
        adGroup: data,
        indexAdGroup,
        indexAd,
        ctx,
      }).safeParse(ad, CAMPAIGN_FORM_ZOD_PARAMS);

      if (!safeAd.success) {
        safeAd.error.issues.forEach((issue) => {
          ctx.addIssue(issue);
        });
      }
    });
  });
